import React from 'react';
import Classes from 'classnames';

export default function FieldRagViewInImport(props) {

    const classes = Classes("ui5-ico-rag",{
        red: props.value===0,
        amber: props.value===1,
        green: props.value===2,
    });

    return (
        <div className={classes}></div>
    );
}